import { useState, useCallback } from "react";

export const useSidebar = () => {
	const [isCollapsed, setIsCollapsed] = useState(false);

	const toggleCollapse = useCallback(() => {
		setIsCollapsed((prev) => !prev);
	}, []);

	const expand = useCallback(() => {
		setIsCollapsed(false);
	}, []);

	const collapse = useCallback(() => {
		setIsCollapsed(true);
	}, []);

	return {
		isCollapsed,
		toggleCollapse,
		expand,
		collapse,
	};
};
